import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-output-statistics',
  templateUrl: './output-statistics.component.html',
  styleUrls: ['./output-statistics.component.scss']
})
export class OutputStatisticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
